import { Map, fromJS } from 'immutable'
import {
  SET_PORTAL_PROCESSING,
  SET_PORTAL_DATA,
  SET_PORTAL_ERROR,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_PORTAL_PROCESSING:
      return state.setIn(['processing'], payload.processing)
    case SET_PORTAL_DATA:
      return state
        .setIn(['data'], fromJS(payload))
        .setIn(['processing'], false)
    case SET_PORTAL_ERROR:
      return state
        .setIn(['error'], payload.error)
        .setIn(['processing'], false)
    default:
      return state
  }
}
